import scrapRoutes from './routes'

/* @ngInject */
const scrapCtrl = (
  $scope,
  $state,
  $$wagon,
  $$train,
  $$railway,
  toaster,
  utils,
) => {
  $scope.$$wagon = $$wagon
  $scope.$$train = $$train
  $scope.$$railway = $$railway

  $scope.fieldsOptions = $$wagon.metadata.fields

  // Separate state for scrap functionality
  $scope.scrapData = {
    mySearchedWagons: [],
    myWagonSearchdata: {},
    mySelectedWagons: [],
    mySelectedIds: [],
    mySelectedLength: 0
  }

  $scope.goToCreateScrapping = () => {
    $state.go(scrapRoutes.createScrapping.path)
  }

  $scope.goToReport = () => {
    $state.go(scrapRoutes.report.path)
  }

  $scope.goToSelectWagons = () => {
    // Clear scrap-specific state
    $scope.scrapData.mySearchedWagons.splice(0, $scope.scrapData.mySearchedWagons.length)
    $scope.scrapData.myWagonSearchdata = {}
    $scope.scrapData.mySelectedWagons.splice(0, $scope.scrapData.mySelectedWagons.length)
    $scope.scrapData.mySelectedIds.splice(0, $scope.scrapData.mySelectedIds.length)
    $scope.scrapData.mySelectedLength = 0
    $state.go(scrapRoutes.selectWagons.path)
  }

  $scope.cancelScrapping = async (_wagonIds) => {
    try {
      const response = await $$wagon.request.cancelScrapping(_wagonIds)
      toaster.message(response)
      $scope.goToSelectWagons()
    }
    catch (error) {
      console.warn(error)
    }
  }

  $scope.enableScrapping = async (_wagonIds, _date) => {
    try {
      _date = utils.date.stringToServer(_date)
      const response = await $$wagon.request.enableScrapping(_wagonIds, _date)
      toaster.message(response)
      $scope.goToReport()
    }
    catch (error) {
      console.warn(error)
    }
  }
}

export default scrapCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/scrap/scrap.controller.js